import React from 'react'
import PropTypes from 'prop-types'

import { map, join } from 'lodash'

import FormGroup from '../components/FormGroup'

const RadioGroup = (props) => {
    const {
        label, input, meta, options, description, isHorizontal, ...otherProps
    } = props
    const { name } = input
    const { error } = meta
    return (
        <FormGroup
            name={ name }
            label={ label }
            error={ error }
            description={ description }
            isHorizontal={ isHorizontal }
        >
            { map(options, (label, value) => {
                const key = join([name, value], '-')
                return (
                    <div className="be-radio be-radio-color inline" key={ key }>
                        <input
                            { ...otherProps }
                            { ...input }
                            id={ key }
                            type="radio"
                            name={ name }
                            value={ value }
                            checked={ value === input.value }
                        />
                        { label && <label htmlFor={ key }>{ label }</label> }
                    </div>
                )
            }) }
        </FormGroup>
    )
}

RadioGroup.propTypes = {
    label        : PropTypes.string,
    input        : PropTypes.object,
    meta         : PropTypes.object,
    description  : PropTypes.string,
    options      : PropTypes.object,
    isHorizontal : PropTypes.bool
}

RadioGroup.defaultProps = {
    isHorizontal: false
}

export default RadioGroup
